/* eslint-disable no-console */
import { Injectable } from '@angular/core';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class LoggerService {
	private readonly initialized: boolean = false;

	constructor() {
		if (environment?.datadog?.isEnabled) {
			datadogRum.init({
				applicationId: environment.datadog.applicationId,
				clientToken: environment.datadog.clientToken,
				defaultPrivacyLevel: environment.datadog.defaultPrivacyLevel,
				env: environment.name,
				service: environment.datadog.service,
				sessionReplaySampleRate: environment.datadog.sessionReplaySampleRate,
				sessionSampleRate: environment.datadog.sessionSampleRate,
				site: environment.datadog.site,
				trackLongTasks: environment.datadog.trackLongTasks,
				trackResources: environment.datadog.trackResources,
				trackUserInteractions: environment.datadog.trackUserInteractions,
			});

			datadogLogs.init({
				clientToken: environment.datadog.clientToken,
				env: environment.name,
				forwardErrorsToLogs: true,
				service: environment.datadog.service,
				sessionSampleRate: environment.datadog.sessionSampleRate,
				site: environment.datadog.site,
			});

			this.initialized = true;
		}
	}

	debug(
		message: string,
		messageContext?: object | undefined,
		error?: Error | undefined,
	): void {
		if (this.initialized) {
			datadogLogs.logger.debug(message, messageContext, error);
		} else {
			console.debug(message, messageContext, error);
		}
	}

	error(
		message: string,
		messageContext?: object | undefined,
		error?: Error | undefined,
	): void {
		if (this.initialized) {
			datadogLogs.logger.error(message, messageContext, error);
		} else {
			console.error(message, messageContext, error);
		}
	}

	info(
		message: string,
		messageContext?: object | undefined,
		error?: Error | undefined,
	): void {
		if (this.initialized) {
			datadogLogs.logger.info(message, messageContext, error);
		} else {
			console.info(message, messageContext, error);
		}
	}

	warn(
		message: string,
		messageContext?: object | undefined,
		error?: Error | undefined,
	): void {
		if (this.initialized) {
			datadogLogs.logger.warn(message, messageContext, error);
		} else {
			console.warn(message, messageContext, error);
		}
	}
}
